import { Component, OnInit } from '@angular/core';
import { FidelidadeService } from '../../_services/fidelidade.service';
import { Router } from '@angular/router';
import { AuthService } from '../../_services/auth.service';

@Component({
  selector: 'app-minhas-experiencias',
  templateUrl: './minhas-experiencias.component.html',
  styleUrls: ['./minhas-experiencias.component.scss'],
})
export class MinhasExperienciasComponent implements OnInit {
  public periodos: any[] = [];
  public periodoSelecionado: number = 0;

  public experiencias: any[] = [];
  public carregandoExperiencias: boolean = false;

  public experienciaSelecionada: any = undefined;
  public mapaAberto: boolean = false;
  public exibeDivSemResgate: boolean = false;

  private membro: any = undefined;

  constructor(private fidelidadeService: FidelidadeService,
    private router: Router,
    private authService: AuthService
    ) {}

  ngOnInit(): void {
    this.carregarPeriodos();
    this.carregarMembroLogado();
  }

  private carregarPeriodos(): void {
    this.periodos = [
      {
        descricao: '5 dias',
        valor: 5,
      },
      {
        descricao: '15 dias',
        valor: 15,
      },
      {
        descricao: '1 mês',
        valor: 30,
      },
      {
        descricao: '2 meses',
        valor: 60,
      },
      {
        descricao: 'Total',
        valor: 0,
      },
    ];
  }

  private carregarMembroLogado(): void {
    this.carregandoExperiencias = true;

    var membro = this.authService.LocalStorage.obterMembro();
    this.processarSucessoObterMembro(membro);
  }

  private processarSucessoObterMembro(res: any): void {
    this.membro = res;
    if (this.membro.tipoStatus === 7 || this.membro.tipoStatus === 11) {
      this.router.navigate(['/meusdados']);
    }
    this.carregarExperiencias();
  }

  public selecionarPeriodo(periodo: number): void {
    this.periodoSelecionado = Number(periodo);
    this.processarSucessoCarregarExperiencias([]);
  }

  private carregarExperiencias(): void {
    this.fidelidadeService
      .obterExtratoExperiencias(this.membro.cpf, this.periodoSelecionado)
      .subscribe({
        next: (res: any) => this.processarSucessoCarregarExperiencias(res),
        error: (err: any) => this.processarFalhaCarregarExperiencias(err),
      });
  }

  private processarSucessoCarregarExperiencias(res: any): void {
    let experiencias: any[] = [];

    for (let i = 0; i < res.resultado.length; i++) {
      const item = res.resultado[i];

      if (item.idPromocaoUsuario === 0) {
        const existePromocoesUsuarios: boolean =
          item.promocoesUsuarios !== null;

        let experiencia = {
          id: item.experienciaParceiro.experiencia.id,
          imagemSrc: item.experienciaParceiro.experiencia.imagemSrc,
          nome: item.experienciaParceiro.experiencia.nome,
          cacaus: item.cacaus,
          unidades: item.experienciaParceiro.experiencia.quantidade,
          unidadesResgatadas: item.quantidade,
          dataResgate: item.dataResgate,
          dataValidade: item.dataFim,
          idStatus: item.idStatus,
          mensagemValidade:
          item.experienciaParceiro.experiencia.mensagemValidade,
          existePromocoesUsuarios: existePromocoesUsuarios,
          tipo: item.experienciaParceiro.experiencia.tipo,
          quantidadePorMembro:
            item.experienciaParceiro.experiencia.quantidadeMembro,
          quantidadeDisponivel: existePromocoesUsuarios
            ? item.promocoesUsuarios?.quantidade
            : 0,
          parceiro: {
            enderecos: item.experienciaParceiro.parceiro.parceiroEndereco,
            imagemSrc: item.experienciaParceiro.parceiro.imagemSrc,
            nome: item.experienciaParceiro.parceiro.nome,
          },
          idExperienciaMembro: item.id,
          idsExperienciaMembro: item.idsResgate,
          mecanicaResgate: item.experienciaParceiro.experiencia.mecanicaResgate,
          experienciaTexto:
            item.experienciaParceiro.experiencia.experienciaTexto,
          promocao: item.experienciaParceiro.experiencia.idPromocao,
          detalhamentoMomentoEspecial:
            item.experienciaParceiro.experiencia.detalhamentoMomentoEspecial,
          cupons: item.cupons,
          prazoEmDias: item.experienciaParceiro.experiencia.prazoEmDias,
          prazoEmData: item.experienciaParceiro.experiencia.prazoEmData,
          parceiroViva: item.parceiroIntegracaoResult !== null ? JSON.parse(item.parceiroIntegracaoResult) : null, //item.parceiroResgateDataResultModel,
          acompanhantes: item.acompanhantes,
          dataEvento: item.experienciaLote?.dataEvento,
        };

        experiencias.push(experiencia);
      } else {
        let experiencia = {
          idPromocaoUsuario: item.idPromocaoUsuario,
          nomePromocao: item.nomePromocao,
          dataResgatePromocao: item.dataResgatePromocao,
          dataValidadeResgatePromocao: item.dataValidadeResgatePromocao,
        };

        experiencias.push(experiencia);
      }
    }

    this.experiencias = experiencias;
    this.carregandoExperiencias = false;

    if (this.experiencias.length <= 0) this.exibirDivSemResgate();
  }

  private processarFalhaCarregarExperiencias(err: any): void {
    this.carregandoExperiencias = false;
    this.exibirDivSemResgate();
    console.error('Ocorreu um erro ao carregar o extrato de experiências', err);
  }

  public abrirMapaExperiencia(index: number): void {
    let experiencia = this.experiencias[index];
    this.experienciaSelecionada = experiencia;
    this.mapaAberto = true;
  }

  public fecharMapaExperiencia(): void {
    this.experienciaSelecionada = undefined;
    this.mapaAberto = false;
  }

  private exibirDivSemResgate() {
    this.exibeDivSemResgate = true;
  }
}
